export default function Header(props) {
    return (
        <div className="header">
            <img className="logo" src="logo.png" alt="Thrilltech" />
            <h1>{props.title}</h1>
            <div className="version">{props.version}</div>
        </div>
    )
}
